import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cpqWelcomeTitle: {
    id: 'cpq.welcomeTitle',
    defaultMessage: 'Welcome to AGCO Configurator',
    description: 'Main title for the CPQ welcome page',
  },
  cpqChooseYourBrand: {
    id: 'cpq.chooseYourBrand',
    defaultMessage: 'Choose your brand',
    description: 'Label for the brand selection field',
  },
});

export default messages;
